export const English = {
  'LANGUAGE_KEY': 'en',
  'language': 'English',
  'exportExcel': 'Export to Excel',
  'loading': 'Loading...',
  'typeToSearch': 'Type to search',
  'collapse': 'Collapse',
  'copyUrl': 'Copy address',
  'sendUrl': 'Send adress by email',
  'attributesHeader': 'Attributes',
  'qaHeader': 'QA',
  'attribute': 'Attributes',
  'attributeSingular': 'Attribute',
  'value': 'Value',
  'unit': 'Unit',
  'qa': 'QA',
  'clip': 'Clip',
  'equipmentsHeader': 'Equipments',
  'equipmentsAnalysisHeader': 'Equipment Analysis',
  'modelType': 'Model type',
  'manufacturer': 'Manufacturer',
  'parentName': 'Parent name',
  'schematicsHeader': 'Schematics',
  'uploadImages': 'Upload images',
  'uploadSchemas': 'Upload schemas',
  'imageViewer': 'Image viewer',
  'categoriesTitle': 'Change image category',
  'categoriesUpdate': 'Update category',
  'legalChild': 'Leagal child nodes',
  'enterNewName': 'Please enter name of new node',
  'addChild' : 'Add child',
  'deleteNode': 'Delete',
  'deleteConfirm': 'Are you sure you want to delete?',
  'save':'Save',
  'delete': 'Delete',
  'cancel': 'Cancel',
  'deleteWithChildNotAllowed': 'Deletion of node with childs is not allowed. Please delete child nodes first',
  'changeModelType': 'Change model type',
  'legalModelTypes': 'Allowed model types',
  'SettingsHeader': 'Settings',
  'clipConnectionError': 'Could not update clip',
  'SelectAll': 'Select all',
  'DeleteImages': 'Delete images',
  'ConfirmDelete': 'Are you sure you wan\'t to delete selected images?',
  'Upload': 'Upload',
  'Browse': 'Browse',
  'Close': 'Close',
  'noSchemaFound': 'No schema found',
  'enterSchemaName': 'Enter the name for schema',
  'CutImages': 'Cut',
  'PasteImages': 'Paste',
  'ClipBoard': 'ClipBoard',
  'schematicsConnectionError': 'Could not update metadata for schema.',
  'startDrawSchematicClips': 'Draw clips',
  'done': 'Done',
  'connectDrawSchematicClips': 'Connect clip',
  'deletingSchemaLink': 'Delete clip',
  'copyingSchemaLink': 'Copy clip',
  'infoTextDrawClips': 'To draw a new clip, click the "Draw clip button, hold CTRL and drag a rectangle on the schema.',
  'infoTextConnectClips': 'To connect a clip to an asset, click the "Connect clip" button, navigate to an asset in the tree, and click the clip in the schema.',
  'infoTextDeleteClips': 'To delete a clip, click the "Delete clip" button, and then click a clip in the schema.',
  'infoTextCopyClips' : 'To copy a clip, click the "Copy clip" button, hold CTRL and drag the copied clip to the desired position',
  'EditImageTitle': 'Edit image category',
  'RotateImage' : 'Rotate image 90 degrees clockwise',
  'ConfirmMove': 'Move selected images?',
  'savingClip': 'Saving clip',
  'deletingClip': 'Deleting clip',
  'dropInfoText': 'Drop images here',
  'schematicsHelpTitle': 'Schematics operations',
  'imageListHeader': 'Thumbnails',
  'manufactureYear': 'Manufactured year',
  'typeDesignation': 'Type',
  'showfullSizeImage': 'Show high resolution',
  'NoSearchResults': 'No match for search word',
  'ExpandImgTooltip': 'Open in new window',
  'contains': 'Contains',
  'doesNotContain': 'Does not contain',
  'isEqualTo': 'Is equal to',
  'isNotEqualTo': 'Is not equal to',
  'startsWith': 'Starts with',
  'endsWith': 'Ends with',
  'and': 'And',
  'or': 'Or',
  'filter': 'Filter',
  'clearFilter': 'Clear filter',
  'filterInfo': 'Show items with value that:',
  'groupInfo': 'Drag a column header and drop it here to group by that column',
  'NoImagesFound': 'No images found',
  'requestFailed': 'Cannot connect',
  'retry': 'Retry',
  'cut': 'Cut',
  'Copy': 'Copy url',
  'CopyToolTip': 'Copy url to clipboard',
  'RowNotSelected': 'No row selected',
  'renameSchematic': 'Rename schematic',
  'enterNewSchemaName': 'Enter the new name for the schema',
  'confirmMove': 'Are you sure you wish to move this node?',
  'documentsHeader': 'Documents',
  'DownloadImage': 'Download image',
  'ToggleRecursiveDocuments': 'Show documents for sub-nodes',
  'showingDocuments': 'Thumbnails for selected document',
  'gotoAsset': 'Go to asset',
  'documentRequirementsHeader': 'Document requirements',
  'SelectNode': 'Select node',
  'clickToShowDocumentFrontpages': 'Select a document to show the front page',
  'ImageList': 'ImageList',
  'Attributes': 'Attributes',
  'Q&A': 'QA',
  'Equipments': 'Equipments',
  'Schematics': 'Schematics',
  'Documents': 'Documents',
  'Document requirements': 'Document requirements',
  'otherTabs': 'Other tabs',
  'showingEquipmentFor': 'Showing equipment for',
  'SelectDocument': 'Select document',
  'toggleClipInfo': 'Show clip information',
  'expand': 'Expand',
  'changeConnectedNode': 'Goto connected node',
  'legalConnectedNodes': 'Connected nodes',
  'ClipNotConnected': 'The clip has no information, or is not connected to an asset.',
  'showClipInfoTooltip': 'Show clip-information',
  'hideClipInfoTooltip': 'Hide clip-information',
  'EqAnCategory': 'Year',
  'EqAnAmount': 'Number',
  'EqAnNoData': 'Navigate in the tree to find documents'
};



/** WEBPACK FOOTER **
 ** app/Localization/en.js
 **/